import { BotIcon, TrendingUpIcon } from "lucide-react";

import { AgenticScoreChip } from "@jobs/pipeline/shared/AgenticScoreChip";
import { Row } from "@/components/Row";
import { Text } from "@/components/Text";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";

import { agenticScoreToBucket } from "@/lib/agenticScore";

// The chip is sized for a card row; inside a line of tooltip copy it only needs
// to match the text's height.
const CHIP_CLASS_NAME = "py-0 leading-5";

// Bot for a real Stevie screen, trending-up when that call moved the candidate
// into a higher rating band. Renders nothing when neither applies.
export const StevieCallIndicators = ({
  currentScore,
  elevatedFrom,
  stevieCallDuration,
}: {
  currentScore: number | null;
  elevatedFrom: number | null;
  stevieCallDuration: number | null;
}) => {
  /* Helpers */
  const elevatedFromBucket = agenticScoreToBucket(elevatedFrom);
  const currentBucket = agenticScoreToBucket(currentScore);
  const hasElevation = elevatedFromBucket !== null && currentBucket !== null;

  /* Render */
  const render = () => {
    if (stevieCallDuration === null && !hasElevation) return null;

    return (
      <TooltipProvider delayDuration={300}>
        <Row className="shrink-0 items-center gap-1">
          {stevieCallDuration !== null ? (
            <Tooltip>
              <TooltipTrigger asChild>
                <Row>
                  <BotIcon className="h-4 w-4 shrink-0 text-primary-700" />
                </Row>
              </TooltipTrigger>
              <TooltipContent>
                <Text className="text-sm font-normal text-slate-700">
                  Stevie - {stevieCallDuration} min
                </Text>
              </TooltipContent>
            </Tooltip>
          ) : null}
          {hasElevation ? (
            <Tooltip>
              <TooltipTrigger asChild>
                <Row>
                  <TrendingUpIcon className="h-4 w-4 shrink-0 text-emerald-600" />
                </Row>
              </TooltipTrigger>
              <TooltipContent>
                <Row className="items-center gap-1.5">
                  <AgenticScoreChip
                    bucket={elevatedFromBucket}
                    className={CHIP_CLASS_NAME}
                  />
                  <Text className="shrink-0 text-sm font-normal text-slate-700">
                    →
                  </Text>
                  <AgenticScoreChip
                    bucket={currentBucket}
                    className={CHIP_CLASS_NAME}
                  />
                  <Text className="shrink-0 text-sm font-normal text-slate-700">
                    - Stevie call
                  </Text>
                </Row>
              </TooltipContent>
            </Tooltip>
          ) : null}
        </Row>
      </TooltipProvider>
    );
  };

  return render();
};
